export function clamp(value: number, min: number, max: number): number {
  if (max < min) return min;
  return Math.min(Math.max(value, min), max);
}

/** True when focus is inside a text field, so global shortcuts should back off. */
export function isInputFocused(): boolean {
  const el = document.activeElement as HTMLElement | null;
  if (!el) return false;
  const tag = el.tagName;
  return (
    tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable === true
  );
}

/** Usable desktop area — the viewport minus the taskbar. */
export function desktopSize(taskbarH: number): { w: number; h: number } {
  if (typeof window === 'undefined') return { w: 1024, h: 768 - taskbarH };
  return { w: window.innerWidth, h: Math.max(0, window.innerHeight - taskbarH) };
}

export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
